import React from 'react';
import { BsSliders } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Icon, IconButton, Tooltip } from '@chakra-ui/react';

import { analyticsIds } from '../../../constants/analyticsIds';
import { setCurrentPage } from '../../../redux/modules/app';
import { selectCompanyId } from '../../../redux/modules/company';

function UserSettingsButton() {
  const dispatch = useDispatch();
  const currentCompanyId = useSelector(selectCompanyId);

  return (
    <Tooltip label="User Settings">
      <NavLink
        to={`/companies/${currentCompanyId}/user-settings`}
        onClick={() => dispatch(setCurrentPage('user-settings'))}
      >
        <IconButton
          colorScheme="black"
          data-analytics-id={analyticsIds.header.userSettingsButton}
          dusk={analyticsIds.header.userSettingsButton}
          icon={<Icon as={BsSliders} boxSize="24px" />}
          variant="textBlack"
        />
      </NavLink>
    </Tooltip>
  );
}

export default UserSettingsButton;
